import { Sheets } from "common/sheets";
export class Shade {
    constructor(sheets) {
        this.sprite = Sheets.sprite(sheets, "쉐이드.png");
    }
}
//# sourceMappingURL=shade.js.map